<template>
    <Modal>
        <template #title>Login</template>

        <form id="form" @submit.prevent="formSubmit">
            <div v-if="errorForm" class="form-error">
                <p>{{ errorForm }}</p>
            </div>

            <div class="form-field">
                <label class="form-field-label">E-mail</label>
                <input type="text" name="email" v-model.trim="email"/>
                <small v-if="errorEmail" class="error-text">{{ errorEmail }}</small>
            </div>

            <div class="form-field">
                <label class="form-field-label">Password</label>
                <input type="password" name="password" v-model.trim="password"/>
                <small v-if="errorPassword" class="error-text">{{ errorPassword }}</small>
            </div>
        </form>

        <p>
            <span class="link float-right" @click="forgotPassword">Forgot password?</span>

            Do not have an account?
            <span class="link" @click="openSignUp">Sign Up</span>
        </p>

        <template #footer>
            <Button class="gray" @click="closeModal">Cancel</Button>

            <Button type="submit" form="form" :loading="sendStatus">Sign In</Button>
        </template>
    </Modal>
</template>

<script>
    import { mapActions } from 'vuex';
    import Modal from "../../components/Modal";
    import Button from "../../components/Button";
    
    export default {
        name: "LoginModal",
        
        components: {
            Button,
            Modal,
        },

        emits: [
            'openSignUp',
            'forgotPassword',
        ],

        data() {
            return {
                sendStatus: false,

                email: '',
                password: '',

                errorForm: false,
                errorEmail: false,
                errorPassword: false,
            }
        },

        methods: {
            ...mapActions('authentication', [
                'login',
            ]),

            closeModal() {
                this.$emit('closeModal');
            },

            resetErrors() {
                this.errorForm = false;
                this.errorEmail = false;
                this.errorPassword = false;
            },

            async formSubmit() {
                this.sendStatus = true;

                this.resetErrors();

                let formData = {
                    email: this.email,
                    password: this.password,
                };

                this.login(formData)
                    .then(() => {
                        // login is success
                        this.closeModal();
                    })
                    .catch(err => {
                        // backend validation errors
                        this.errorForm = err['form'];
                        this.errorEmail = err['email'];
                        this.errorPassword = err['password'];
                    })
                    .finally(() => {
                        this.sendStatus = false;
                    });
            },

            openSignUp() {
                this.$emit('openSignUp');
            },

            forgotPassword() {
                this.$emit('forgotPassword');
            },

        },

    }
</script>

<style scoped>

</style>